<!--
 * @Author: wsx
 * @Date: 2022-01-05 11:00:00
 * @LastEditTime: 2022-02-16 10:24:03
 * @LastEditors: Please set LastEditors
 * @Description:二维地图
-->
<template>
  <div class="MyMap MyMapStyle">
    <div id="myMap" v-if="mapTime"></div>

    <div class="test-map">
      <div
        v-show="showOperationPoint"
        class="icon"
        :class="`icon` + iconNum"
        @click="showVideo"
      >
        <x-icon type="icon-shexiangji1" size="24px"></x-icon>
        <span>{{ iconNum == 1 ? "隐藏" : "展示" }}</span>
      </div>
      <!-- showOperation -->
      <div v-show="showOperation">
        <slot name="first"></slot>
        <el-button @click="clickDrawArea('Polygon')" :disabled="drawDisabled"
          >绘制区域</el-button
        >
        <el-button @click="clickDrawArea('Circle')" :disabled="drawDisabled"
          >绘制圆</el-button
        >
        <!-- <el-button @click="clickRemDraw">清除绘制</el-button> -->
        <!-- <el-button @click="opertionBack">清空</el-button> -->
        <slot name="back"></slot>
      </div>

      <!-- <el-button @click="delPoint">删除点位</el-button> -->
      <!-- <el-button @click="loadMarker">添加点位</el-button> -->
      <!-- <el-button @click="addInteractions">绘制区域</el-button>
      <el-button @click="remDraw">清除绘制</el-button>
      <el-button @click="loadMarker">添加点位</el-button>
      <el-button @click="drawArea">渲染区域</el-button>

      <el-button @click="remArea">清除区域</el-button>
      <el-button @click="mapLocation([108.390234, 31.205174])">定位</el-button>
      <el-button @click="delPoint">删除点位</el-button>
      <el-button @click="clearMarker">清空点位</el-button>
      <br /> -->
      <!-- <el-button @click="distanceMeasure">测距</el-button> -->
      <!-- <el-button @click="clickDrawArea">绘制区域</el-button>
      <el-button @click="remDraw">清除绘制</el-button> -->
    </div>
    <template v-if="pointStatus">
      <template v-for="item in devivePointInfoArray" :key="item.id">
        <CameraPoint :infoData="item"></CameraPoint>
      </template>
      <template v-for="item in pointArraysList" :key="item.id">
        <DevicePoint :infoData="item"></DevicePoint>
      </template>
    </template>
  </div>
</template>
<script>
import {
  defineComponent,
  nextTick,
  reactive,
  toRefs,
  onMounted,
  computed,
  toRaw,
  watchEffect,
} from "vue";
import mapApi from "./js/MapApi";
import CompanyPoint from "./pointCompont/CompanyPoint.vue";
import CameraPoint from "./pointCompont/CameraPoint.vue";
import DevicePoint from "./pointCompont/DevicePoint.vue";
export default defineComponent({
  name: "MyMap",
  components: { CameraPoint, DevicePoint },
  props: {
    /**
     * point-pick 点位拾取；
     */
    features: {
      type: String,
      default: "",
    },
    pointArraysList: {
      type: Object,
      default: [],
    },
    devivePointInfoArray: {
      type: Object,
      default: [],
    },
    showOperationPoint: {
      type: Boolean,
      default: false,
    },
  },
  // emits: ["clickMap", "drawArea"],
  setup(props, { emit }) {
    const state = reactive({
      currentPoint: [],
      iconNum: 1,
      features: "",
      pointStatus: false,
      mapTime: false,
      showOperation: false,
      selectPoint: false,
      pointArray: null, //暂存地图点位
      drawDisabled: false, //结束绘制前按钮不可用
      listenMapClick: true, //结束绘制前按钮不可用
    });
    const refDatas = toRefs(state);
    const features = computed(() => props.features);
    const {
      initOlMap,
      addInteractions,
      remDraw,
      remAllDraw,
      renderArea,
      remArea,
      mapLocation,
      addMarker,
      remMarker,
      clearMarker,
      distanceMeasure,
      loadMap,
      clickMap,
      cancelClickMap,
      resetMap,
      drawComponment,
      mapLineInit,
      mapLine,
      mapLineArrow,
      mapLineArrowArr,
      mapLineArrowArrDel,
      mapMoveAddLine,
      mapStartMoveAddLine,
      mapStopMoveAddLine,
      clearMoveAddLine,
      clearLine,
      stopMapLine,
      startMapLine,
      changeMoveSpeed,
      getMapLineDistance,
      getDistanceApi,
      addHeatmap,
      clearHeatmap,
    } = mapApi();
    onMounted(() => {
      setTimeout(() => {
        state.mapTime = true;
        nextTick(() => {
          const target = document.getElementById("myMap");
          initOlMap(target);
        });
      });
    });
    loadMap(() => {
      if (features.value === "draw-area") {
        addInteractions("Polygon", (corrdinates) => {
          emit("drawArea", corrdinates);
        });
      } else if (features.value === "draw-line") {
        addInteractions("LineString", (corrdinates) => {
          emit("drawArea", corrdinates);
        });
      }
      state.pointStatus = true;
      emit("loadMapSuccess");
    });
    clickMap(async (e, point, zoom) => {
      state.currentPoint = point;
      emit("clickMap", e, point, zoom);
      if (features.value === "point-pick") {
        // 点位拾取并在左边位置添加点位
        await clearMarker();
        addMarker({
          name: "点位3",
          showType: 2,
          location: point,
        });
      }
    });
    const showVideo = () => {
      if (state.iconNum == 1) {
        clearPoint();
      } else {
        loadMarker(state.pointArray);
      }
      state.iconNum = state.iconNum == 1 ? 2 : 1;
    };
    // 重新绘制区域
    const redrawArea = () => {
      remDraw();
      addInteractions();
    };
    const drawArea = (data, areaColor) => {
      const list = [
        [
          [108.297302259505, 31.1691893402034],
          [108.430469565178, 31.2092152127588],
          [108.481348219725, 31.1644199309515],
          [108.324269416454, 31.1224893886959],
          [108.297302259505, 31.1691893402034],
        ],
      ];
      renderArea(data, areaColor);
    };
    //清除渲染的区域
    const clearArea = () => {
      remArea();
      // remAllDraw();
    };
    // 加载点位
    const loadMarker = (pointArray) => {
      const list = toRaw(pointArray);
      state.pointArray = list;
      list.forEach((item) => {
        addMarker(item);
      });
    };
    //删除点位
    const delPoint = (pointArray) => {
      // remMarker(1);
      const list = toRaw(pointArray);
      list.forEach((item) => {
        remMarker(item.id);
      });
    };
    // 清空点位
    const clearPoint = () => {
      clearMarker();
    };
    // 绘制路径
    const clickDrawLine = (polyline) => {
      // const polyline = [
      //   [108.431706, 31.183164],
      //   [108.426817, 31.184857],
      //   [108.394475, 31.165026],
      //   [108.393777, 31.180281],
      // ];
      console.log(polyline);
      mapLine(polyline);
    };
    const clickClearLine = () => {
      clearLine();
    };
    const clickMapLineInit = () => {
      mapLineInit();
    };
    const startLine = () => {
      startMapLine();
    };
    const stopLine = () => {
      stopMapLine();
    };
    const changeSpeed = (speed) => {
      changeMoveSpeed(speed);
    };
    const getLineDistance = () => {
      let dis = getMapLineDistance();
      return dis;
    };

    // 点击绘制
    // type:"LineString" "Polygon"  "Circle"  绘制圆或不规则图型
    const clickDrawArea = (type, addDel) => {
      state.drawDisabled = true;
      addInteractions(
        type,
        (corrdinates) => {
          state.drawDisabled = false;
          emit("drawArea", corrdinates);
        },
        addDel
      );
    };
    // 清除绘制
    const clickRemDraw = () => {
      state.drawDisabled = false;
      // remDraw((corrdinatesArray) => {
      //   emit("drawArea", corrdinatesArray);
      // });
      remAllDraw();
      emit("drawArea", []);
    };
    // 添加点位信息
    const drawPointInfo = (el, piont, drawOption) => {
      drawComponment(el, piont, drawOption);
    };
    // 显示操作按钮
    const opertionBtn = () => {
      state.showOperation = true;
    };
    // 退出操作按钮
    const opertionBack = () => {
      state.showOperation = false;
      state.drawDisabled = false;
      remAllDraw();
      emit("drawArea", []);
    };
    // 点击地图获取点位
    const getPointClick = () => {
      if (state.currentPoint.length > 0) {
        remMarker(-1);
      }
      state.listenMapClick = true;
      clickMap(async (e, point) => {
        if (!state.listenMapClick) return;
        state.currentPoint = point;
        emit("clickMap", e, point);
        addMarker({
          id: -1,
          name: "点位3",
          showType: 2,
          location: point,
        });
      });
    };
    // 点击地图删除点
    const delPointClick = () => {
      remMarker(-1);
      state.listenMapClick = false;
    };
    // 添加热力图
    const clickaddHeatmap = (list) => {
      const data = [
        {
          type: "Point",
          coordinates: [108.297302259505, 31.1691893402034],
          weight: 100,
        },
        {
          type: "Point",
          coordinates: [108.430469565178, 31.2092152127588],
          weight: 19,
        },
      ];

      addHeatmap(list);
    };

    return {
      ...refDatas,
      showVideo,
      addInteractions,
      remDraw,
      drawArea,
      remArea,
      clearArea,
      mapLocation,
      loadMarker,
      delPoint,
      clearPoint,
      clearMarker,
      distanceMeasure,
      resetMap,
      redrawArea,
      drawPointInfo,
      opertionBtn,
      opertionBack,
      clickDrawArea,
      clickDrawLine,
      mapLineArrow,
      mapLineArrowArr,
      mapLineArrowArrDel,
      mapMoveAddLine,
      mapStartMoveAddLine,
      mapStopMoveAddLine,
      clearMoveAddLine,
      clickRemDraw,
      clickClearLine,
      clickMapLineInit,
      startLine,
      stopLine,
      changeSpeed,
      getLineDistance,
      getDistanceApi,
      getPointClick,
      cancelClickMap,
      clickaddHeatmap,
      clearHeatmap,
      remAllDraw,
      delPointClick,
    };
  },
});
</script>

<style lang="scss">
@import "./style/map.scss";
</style>
<style lang="scss" scoped>
.MyMap {
  width: 100%;
  height: 100%;
  position: relative;
  #myMap {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    background-color: var(--el-bg-color);
    &::before {
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      pointer-events: none;
      z-index: 1;
      background-color: rgba($color: #001551, $alpha: 0.1);
    }
  }
}
.test-map {
  position: absolute;
  top: 3%;
  right: 5%;
  z-index: 3;
  color: #fff;
  .icon {
    position: absolute;
    right: 0px;
    top: 28px;
    height: 50px;
    width: 50px;
    font-size: 20px;
    background-color: #729ef8;
    border-radius: 50%;
    margin-right: 10px;
    z-index: 10;
    cursor: pointer;
    @include flex-col-c-c;
    &.icon1 {
      background-color: #72ddb2;
    }
    &.icon2 {
      background-color: #9a9ca3;
    }
    span {
      font-size: 14px;
    }
  }
}
</style>
